(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rsp-bright-shop"] && !Shopify.designMode) return;
  try {
    
function initRspShop(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  let category = '';
  const cards = Array.from(root.querySelectorAll('[data-shop-card]'));
  const search = root.querySelector('[data-shop-search]');
  function filterCards() {
    const term = search.value.trim().toLowerCase();
    let count = 0;
    cards.forEach(card => {
      const tags = card.dataset.tags.split('|');
      const matchesCategory = !category || tags.some(tag => tag === category || tag === 'gender-' + category || tag === 'for-' + category || tag === 'audience-' + category);
      const visible = matchesCategory && card.dataset.search.includes(term);
      card.hidden = !visible;
      if (visible) count++;
    });
    root.querySelector('[data-shop-empty]').hidden = count !== 0;
  }
  search.addEventListener('input', filterCards);
  root.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => {
    category = button.dataset.filter;
    root.querySelectorAll('[data-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    filterCards();
  }));
  root.querySelectorAll('[data-shop-size]').forEach(select => select.addEventListener('change', () => {
    const card = select.closest('[data-shop-card]');
    card.querySelector('input[name="id"]').value = select.value;
    card.querySelector('[data-card-price]').textContent = select.selectedOptions[0].dataset.price;
  }));
}
document.querySelectorAll('[data-rsp-shop]').forEach(initRspShop);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-rsp-shop]').forEach(initRspShop));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rsp-luxury-discovery"] && !Shopify.designMode) return;
  try {
    
function initRspDiscovery(root) {
  if (root.dataset.discoveryReady) return;
  root.dataset.discoveryReady = 'true';
  const track = root.querySelector('[data-discovery-track]');
  const previous = root.querySelector('[data-discovery-prev]');
  const next = root.querySelector('[data-discovery-next]');
  if (!track || !previous || !next) return;
  const update = () => {
    previous.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  };
  const move = direction => {
    const card = track.querySelector('article');
    if (!card) return;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const amount = (card.getBoundingClientRect().width + gap) * direction;
    track.scrollBy({left: amount, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  };
  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  track.addEventListener('scroll', update, {passive:true});
  window.addEventListener('resize', update, {passive:true});
  update();
}
document.querySelectorAll('[data-rsp-discovery]').forEach(initRspDiscovery);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-rsp-discovery]').forEach(initRspDiscovery));

  } catch(e) { console.error(e); }
})();
})();
